(() => {
  const catalogue = document.getElementById('RedWineCatalogue');
  if (!(catalogue instanceof HTMLDetailsElement)) return;
  catalogue.querySelectorAll('.hk-collection-tags a[href]').forEach((link) => {
    const target = new URL(link.href, window.location.href);
    target.hash = 'RedWineCatalogue';
    link.href = target.href;
  });
  const revealFromHash = () => {
    if (!['#RedWineCatalogue', '#CollectionGridTitle', '#ProductGridContainer'].includes(window.location.hash)) return;
    catalogue.open = true;
    document.getElementById(window.location.hash.slice(1))?.scrollIntoView({ block: 'start' });
  };
  document.querySelectorAll('a[href="#RedWineCatalogue"]').forEach((link) => {
    link.addEventListener('click', () => { catalogue.open = true; });
  });
  window.addEventListener('hashchange', revealFromHash);
  revealFromHash();
})();
